<script setup>
import { formattedDate, humanizeText, swalError, swalSuccess } from '@/helper';
import { get_ticket, update_ticket } from '@/services/tickets';
import { get_user } from '@/services/user';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import rewardCard from '@/components/rewardCard.vue'

const route = useRoute()
const ticket = ref({})
const user = ref({})
const isLoading = ref(true)
onMounted(async()=>{
  await retrieve_ticket()
  await retrieve_user()
  if (ticket.value.attributes.ticket_type == 'feedback'){
    meta.value = parseMeta(ticket.value.attributes.meta)
    questions.value = meta.value.questions
  }
  status.value.val = ticket.value.attributes.status
  isLoading.value = false
})

async function retrieve_ticket(){
  let response = await get_ticket(route.params.id)
  if (response.error){
    swalError(response.result.error, true)
    return
  }
  ticket.value = response.result.data.data
}

async function retrieve_user(){
  let response = await get_user(ticket.value.attributes.user_id)
  if (response.error){
    swalError(response.message)
    return
  }
  user.value = response.data.data.attributes
}

const questions = ref([])
const meta = ref({})
function parseMeta(data){
  let formatted
  formatted = JSON.parse(data)
  return formatted
}

function getText(data){
  let text = ''
  switch (data) {
    case 'support_ticket':
      text = 'support ticket'
      break;
    case 'feedback':
      text = 'feedback'
      break;
    default:
      break;
  }
  return text
}

const title = computed(()=>{
  if (ticket.value.attributes){
    if (ticket.value.attributes.ticket_type == 'feedback'){
      return 'Intervention Feedback'
    }
    if (ticket.value.attributes.ticket_type == 'support_ticket'){
      return 'Support'
    }
    return humanizeText(ticket.value.attributes.ticket_type)
  }else{
    return 'Ticket'
  }
})

const status = ref({
  val: ''
})

const statusOption = ref([
  {
    valueProp: 'on_hold',
    label: 'On Hold',
    disabled: false
  },
  {
    valueProp: '',
    label: 'Open',
    disabled: false
  },
  {
    valueProp: 'closed',
    label: 'Closed',
    disabled: false
  },
]
)

async function updateTicketStatus(){
  let param = {
    status: status.value.val
  }
  let response = await update_ticket(ticket.value.id, param)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Ticket status has been update')
}

async function archiveTicket(){
  let params = {
    is_archive: 1
  }
  let response = await update_ticket(ticket.value.id, params)
  if(response.error){
    swalError(response.result, true)
    return
  }
  ticket.attributes.is_archive = 1
  swalSuccess("Ticket has been archive")
}
</script>

<template>
  <Breadcrumbs :main="title + ' Ticket'"/>
  
  <div class="container-fluid">
    <template v-if="isLoading">
      <loadingCard />
    </template>
    <div v-else class="row">
      <!-- User Info -->
      <div class="col-md-6">
        <div class="card">
          <div class="card-header py-3">
            <h4 class="mb-0">User Info</h4>
          </div>
          <div class="card-body">
            <p class="mb-0">
              <b>Name:</b>
              {{ user.first_name }} {{ user.last_name }}
            </p>
            <p class="mb-0">
              <b>Email:</b>
              {{ user.email }}
            </p>
            <p class="mb-0">
              <b>Register On:</b>
              {{ formattedDate(user.created_at) }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-if="ticket.attributes.ticket_type == 'support_ticket'" >
        <div class="card">
          <div class="card-header py-3">
            <h4 class="mb-0">Ticket Status</h4>
          </div>
          <div class="card-body">
            <multiselect 
              v-model="status.val" 
              placeholder="Select status"
              :options="statusOption"
              valueProp="valueProp"
              :searchable="true"
            ></multiselect>
            <button class="btn btn-light-success mt-2 float-end"
              @click="updateTicketStatus"
            >
              Update
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6"
        v-if="ticket.attributes.ticket_type !== 'support_ticket'"
      >
        <rewardCard :ticket="ticket" :meta="meta" />
      </div>

      <!-- Ticket Info -->
      <div class="card">
        <div class="card-header py-3">
          <div class="d-flex justify-content-between">
            <h4 class="mb-0">{{ ticket.attributes.topic }}</h4>
            <button class="btn btn-light-danger" 
              @click='archiveTicket()'
              :class="ticket.attributes.is_archive ? 'disabled' : ''"
            >
              Archive {{ getText(ticket.attributes.ticket_type) }}
            </button>

          </div>
        </div>
        <div class="card-body pt-3">
          <div class="card shadow-none border mt-3">
            <div v-if="ticket.attributes.ticket_type == 'support_ticket'" class="card-body">
              <p>
                <b>Subject : </b>
                {{ ticket.attributes.subject }}
              </p>
              <p>
                <b>Message : </b>
                {{ ticket.attributes.description }}
              </p>
            </div>
            <div v-if="ticket.attributes.ticket_type == 'feedback'" class="card-body">
              <div v-for="item in questions" class="mb-3">
                <p class="mb-0 fw-medium tracking-widest">{{ item.title }}</p>
                <p>Answer: {{ item.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>